import { render, staticRenderFns } from "./SimpleQuarterTable.vue?vue&type=template&id=341b57c0&scoped=true&"
import script from "./SimpleQuarterTable.vue?vue&type=script&lang=js&"
export * from "./SimpleQuarterTable.vue?vue&type=script&lang=js&"
import style0 from "./SimpleQuarterTable.vue?vue&type=style&index=0&id=341b57c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341b57c0",
  null
  
)

export default component.exports